module.exports = __webpack_public_path__ + "img/wind-turbine.f2211090.svg";